// extracted by mini-css-extract-plugin
export default {"booking":"Booking_booking__aWMHC","icon-naver":"Booking_icon-naver__M31EU","icon-kakao":"Booking_icon-kakao__Y84JX","icon-phone":"Booking_icon-phone__u7vxP"};